import logs from '@/services/apiCalls/logs'
import putLogs from '@/utils/putLogs'

export default (err, context) => {
  console.error(err)

  const errParsed =
    (err && err.message) || (err && err.errors && err.errors[0] && err.errors[0].message)

  if (errParsed === 'Refresh Token has expired') {
    context.$route.push({ name: 'login' })
  }

  context.$store.commit('setAppErrorCardState', {
    state: true,
    errorText: errParsed || err,
  })

  putLogs(err)
    .catch(err => {
      const errorInfo = err && err.errors && err.errors[0] && err.errors[0].errorInfo;
      if (errorInfo && errorInfo.message === "The specified log stream does not exist.") {
        logs.createLogStream().then(() => {
          putLogs(err);
        });
      }
      if (errorInfo && (errorInfo.__type === "InvalidSequenceTokenException" || errorInfo.__type === "DataAlreadyAcceptedException")) {
        context.$store.commit('setNextSequenceToken', err.errors[0].errorInfo.expectedSequenceToken);
        putLogs(err);
      }
    })
}
